import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import ProductBrief from "../Product/ProductBrief";
import ElementSpareEdit from "./ElementSpareEdit";

export default class ElementSpare extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      edit: false,
      currentItemId: null,
      defaultEditValues: {},
      demands: {},
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.elementId !== this.props.elementId) {
      this.load();
    }
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  loadReferences = async () => {};

  load = async () => {
    const { elementId } = this.props;
    this.setState({ pending: true });

    let demands = {};
    let allDemands = await this.context.api.qa("/demand/list", {
      filter: { element: elementId },
      orderby: ["modelname DESC"],
    });
    allDemands.forEach((item) => {
      const { model } = item;
      if (model) {
        let demand = demands[model] || {};
        if (!demand.volume) demand.volume = {};
        if (!demand.id) demand.id = {};
        if (!demand.measure) demand.measure = {};
        demand.model = item.model;
        demand.label = item.modelname;
        demand.code = item.modelcode;
        demand.subcode = item.modelsubcode;
        demand.description = item.modeldescription;
        demand.volume[item.typecode] = item.volume;
        demand.id[item.typecode] = item.id;
        demand.measure[item.typecode] = item.measurename;
        demand.storage = {
          open: false,
          pending: false,
          lines: [],
        };

        demands[model] = demand;
      }
    });

    this.setState({ demands, pending: false });
  };

  save = async () => {};

  onAddOpen = (defaultValues = {}) => {
    this.setState({
      edit: true,
      currentItemId: null,
      defaultEditValues: defaultValues,
    });
  };

  onDelete = async (currentItemId) => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/demand/delete", {
      id: currentItemId,
    });

    if (result !== false) {
      this.context.toast("Значение удалено", "success");
      this.load();
    } else {
      this.setState({ pending: false });
      this.context.toast("Не удалось удалить занчение", "error");
    }
  };

  onEditOpen = (currentItemId) => {
    this.setState({ edit: true, currentItemId });
  };

  onEditHide = () => {
    this.setState({ edit: false });
  };

  onAfterSave = () => {
    this.setState({ edit: false });
    this.load();
  };

  onCartAdd = async (modelId) => {
    if (modelId) {
      this.setState({ pending: true });
      let result = await this.context.cart.addItem(modelId);
      if (result === false) {
        this.context.toast("Не удалось добавить в подборку", "error");
      } else {
        this.context.toast("Добавлено в подборку", "success");
      }
      this.context.force();
      this.setState({ pending: false });
    }
  };

  onToggleStorage = async (modelId) => {
    if (modelId) {
      let { demands } = this.state;
      let demand = demands[modelId];
      if (demand) {
        if (demand.storage.open) {
          demand.storage.open = false;
          demand.storage.pending = false;
        } else {
          demand.storage = {
            open: true,
            pending: true,
            lines: [],
          };

          this.loadStorageLines(modelId);
        }
      }
      this.setState({ demands });
    }
  };

  loadStorageLines = async (modelId) => {
    if (modelId) {
      let { demands } = this.state;
      let demand = demands[modelId];
      if (demand) {
        demand.storage.lines = await this.context.api.qa("/product/list", {
          filter: { model: modelId },
        });
        demand.storage.pending = false;
        this.setState({ demands });
      }
    }
  };

  render() {
    const { pending, edit, demands } = this.state;

    const volumeItem = (demand, type) => {
      const { volume, measure, id } = demand || {};
      const volumeExists = volume[type] || volume[type] === 0 ? true : false;

      return (
        <div>
          {volumeExists && (
            <>
              {this.props.manageSpare && (
                <>
                  <span
                    onClick={(e) => this.onEditOpen(id[type])}
                    className="cursor-pointer text-hover-primary"
                  >
                    {volume[type]}{" "}
                    <span className="text-muted small">{measure[type]}</span>
                  </span>
                  <i
                    className="fa fa-times cursor-pointer text-hover-danger ml-2"
                    onClick={(e) => this.onDelete(id[type])}
                    title="Удалить"
                  ></i>
                </>
              )}
              {!this.props.manageSpare && (
                <span>
                  {volume[type]}{" "}
                  <span className="text-muted small">{measure[type]}</span>
                </span>
              )}
            </>
          )}
          {!volumeExists && this.props.manageSpare && (
            <>
              <i
                className="fa fa-plus cursor-pointer text-hover-primary"
                onClick={(e) =>
                  this.onAddOpen({ model: demand.model, typecode: type })
                }
                title="Добавить"
              ></i>
            </>
          )}
        </div>
      );
    };

    return (
      <>
        {edit && (
          <ElementSpareEdit
            elementId={this.props.elementId}
            itemId={this.state.currentItemId}
            onHide={this.onEditHide}
            onAfterSave={this.onAfterSave}
            defaultValues={this.state.defaultEditValues}
            manageSpare={this.props.manageSpare}
            manageModel={this.props.manageModel}
          />
        )}
        <Blocker on={pending}>
          <div className="row pb-5 mb-5 border-bottom text-muted font-italic align-items-end">
            <div className="col-6">Запчасть: </div>
            <div className="col">КО</div>
            <div className="col">Судовладелец</div>
          </div>
          {Object.entries(demands).map(([modelId, demand]) => {
            let storage = demand.storage || {};

            return (
              <div key={modelId}>
                <div className="row mt-3">
                  <div className="col-6">
                    <div>
                      <i
                        onClick={() => this.onToggleStorage(modelId)}
                        className={`mr-2 fa ${
                          storage.open
                            ? "fa-minus-square-o"
                            : "fa-plus-square-o"
                        }  text-muted text-hover-primary cursor-pointer`}
                        title="Складские запасы"
                      ></i>
                      {demand.label}
                    </div>
                    <div>
                      {demand.code && (
                        <span className="small mr-2 text-dark-50">
                          {demand.code}
                        </span>
                      )}
                      {demand.subcode && (
                        <span className="small mr-2 text-dark-75">
                          {demand.subcode}
                        </span>
                      )}
                    </div>
                    {demand.description && (
                      <div className="small text-dark-25">
                        {demand.description}
                      </div>
                    )}
                  </div>
                  <div className="col">{volumeItem(demand, "cs.demand")}</div>
                  <div className="col">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        {volumeItem(demand, "so.demand")}
                      </div>
                      <i
                        onClick={() => this.onCartAdd(modelId)}
                        className="mr-3 fa fa-cart-plus text-muted text-hover-primary cursor-pointer"
                        title="Добавить в подборку"
                      ></i>
                    </div>
                  </div>
                </div>
                {storage.open && (
                  <div className="py-4 pl-5 mt-2">
                    <Blocker on={storage.pending} hAuto>
                      {storage.lines.length === 0 && !storage.pending && (
                        <div className="text-muted font-italic">
                          Информация о наличии не найдена
                        </div>
                      )}
                      {storage.lines.length > 0 && (
                        <div>
                          {storage.lines.map((line) => {
                            return (
                              <div
                                key={line.id}
                                className="mb-3 pb-3 border-bottom"
                              >
                                <ProductBrief
                                  row
                                  storageLink
                                  {...line}
                                  suffix={
                                    <i
                                      onClick={() => this.onCartAdd(line.id)}
                                      className="mr-4 fa fa-cart-plus text-muted text-hover-primary cursor-pointer"
                                      title="Добавить в подборку"
                                    ></i>
                                  }
                                />
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </Blocker>
                  </div>
                )}
              </div>
            );
          })}
          {this.props.manageSpare && (
            <div className="mt-5 pt-5 border-top">
              <div className="d-flex justify-content-between">
                <div>
                  <div
                    className="btn btn-primary"
                    onClick={() => this.onAddOpen({})}
                  >
                    Добавить позицию
                  </div>
                </div>
              </div>
            </div>
          )}
        </Blocker>
      </>
    );
  }
}
